import { render, staticRenderFns } from "./TradePasswordModal.vue?vue&type=template&id=cd98a452&scoped=true"
import script from "./TradePasswordModal.vue?vue&type=script&lang=js"
export * from "./TradePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./TradePasswordModal.vue?vue&type=style&index=0&id=cd98a452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd98a452",
  null
  
)

export default component.exports